import {lazy} from "react";

// Public pages
export const DogList = lazy(() => import("pages/listViews/dogs"));
export const BreederList = lazy(() => import("pages/listViews/breeders"));
export const LitterList = lazy(() => import("pages/listViews/litters"));
export const OrganizationProfile = lazy(() => import("pages/organizationProfile"));
export const DogEdit = lazy(() => import("pages/dogEdit"));
export const DogProfile = lazy(() => import("pages/dogProfile"));
export const BreederProfile = lazy(() => import("pages/breederProfile"));
export const LitterProfile = lazy(() => import("pages/litterProfile"));
export const Home = lazy(() => import("pages/home"));
export const Privacy = lazy(() => import("pages/privacy"));
export const Terms = lazy(() => import("pages/terms"));
export const NotFound = lazy(() => import("pages/notfound"));
export const Search = lazy(() => import("components/search"));

// Private pages
export const UserProfile = lazy(() => import("pages/userProfile"));
export const MyDogs = lazy(() => import("pages/myDogs"));
export const BredDogs = lazy(() => import("pages/myLitters"));
export const DogRegistrationContainer = lazy(() => import("pages/dogRegistration/dogRegistrationContainer"));
export const PedigreeTool = lazy(() => import("pages/pedigreeTool"));
export const Registrations = lazy(() => import("pages/usersRegistrations"));
export const LitterRegistrationContainer = lazy(() => import("pages/litterRegistration/litterRegistrationContainer"));
export const LitterPaymentSuccess = lazy(() => import("pages/litterRegistration/paymentSuccess"));
export const DogPaymentSuccess = lazy(() => import("pages/dogRegistration/paymentSuccess"));

// Admin pages
export const AdminDashboard = lazy(() => import("pages/adminDashboard/views/dashboard/dashboard"));
export const AdminAllDogs = lazy(() => import("pages/adminDashboard/views/allDogs"));
export const AdminView = lazy(() => import("pages/adminDashboard/views/container"));
export const AdminDogView = lazy(() => import("pages/adminDashboard/views/dog"));
export const AdminCreateDogDiffView = lazy(() =>
  import("pages/adminDashboard/views/dog").then((m) => ({default: m.AdminCreateDogDiffView})),
);
export const AdminAllPendingDogs = lazy(() => import("pages/adminDashboard/views/allPendingDogs"));
export const AdminAllUsers = lazy(() => import("pages/adminDashboard/views/allUsers"));
export const AdminUserView = lazy(() => import("pages/adminDashboard/views/user"));
export const AdminAllPendingLitters = lazy(() => import("pages/adminDashboard/views/allPendingLitters"));
export const AdminLitterView = lazy(() => import("pages/adminDashboard/views/litter"));
export const AdminAllLitters = lazy(() => import("pages/adminDashboard/views/allLitters"));
export const AdminAllTreedogs = lazy(() => import("pages/adminDashboard/views/allTreedogs"));
export const AdminAllOrganizations = lazy(() => import("pages/adminDashboard/views/allOrganizations"));
export const AdminOrganizationView = lazy(() => import("pages/adminDashboard/views/organization"));
export const AdminAllCertificates = lazy(() => import("pages/adminDashboard/views/allCertificates"));
export const AdminCertificateView = lazy(() => import("pages/adminDashboard/views/certificate"));
export const AdminAllResultproviders = lazy(() => import("pages/adminDashboard/views/allResultproviders"));
export const AdminResultproviderView = lazy(() => import("pages/adminDashboard/views/resultprovider"));
export const TreedogAdditionContainer = lazy(
  () => import("pages/adminDashboard/views/treedogAddition/treedogAdditionContainer"),
);
export const TreedogAdditionSuccess = lazy(
  () => import("pages/adminDashboard/views/treedogAddition/treedogAdditionSuccess"),
);
